import { get, flatten } from 'lodash';
import geoViewport from '@mapbox/geo-viewport';
import { call, select, put } from 'redux-saga/effects';
import { getBbox } from '../../reports/sagas/get-bbox';
import { makeFilterString } from '../../filters/helpers';
import { getQueryString, getServerConfig } from '../../api';

export const getFilters = ({ filters }) => filters;

export function* fetchFilterBbox(action) {
  const { layer } = get(action, 'payload.config', {});
  const serverConfig = yield select(getServerConfig);
  const filters = yield select(getFilters);
  const querystring = yield select(getQueryString);
  const filterString = makeFilterString(
    layer.filters,
    (filters[0].type === 'PARENT')
      ? filters.find(({ source }) => source === layer.source).filters
      : filters,
    querystring,
  );
  const bboxResult = yield call(getBbox, { serverConfig, filterString });

  const viewport = geoViewport.viewport(flatten(bboxResult.bboxes[0]), [640, 480]);

  yield put({
    type: 'SET_MAP_SETTINGS',
    payload: {
      id: 'MAIN_MAP',
      settings: {
        center: {
          lng: viewport.center[0],
          lat: viewport.center[1],
        },
        zoom: viewport.zoom,
      },
    },
  });
}
